import type { FunctionComponent, SVGProps } from 'react';
import Icon from './Icon';

const ArrowCircleUp: FunctionComponent<SVGProps<SVGSVGElement>> = (props) => (
  <Icon width="512px" height="512px" viewBox="0 0 512 512" {...props}>
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
      <path
        d="M2236 5094 c-1150 -148 -2069 -1071 -2211 -2224 -20 -161 -20 -459 0
-620 143 -1159 1066 -2082 2225 -2225 161 -20 459 -20 620 0 1159 143 2082
1066 2225 2225 20 161 20 459 0 620 -143 1159 -1066 2082 -2225 2225 -154 19
-482 18 -634 -1z m514 -375 c513 -46 975 -263 1340 -629 376 -376 589 -841
632 -1378 34 -430 -79 -899 -305 -1270 -224 -366 -565 -672 -947 -849 -729
-338 -1577 -245 -2223 244 -200 151 -409 384 -544 605 -226 371 -339 840 -305
1271 43 536 256 1001 632 1377 458 458 1084 687 1720 629z"
      />
      <path
        d="M2485 3311 c-27 -13 -210 -189 -562 -542 -463 -465 -522 -528 -529
-562 -23 -128 65 -242 186 -240 26 0 62 8 81 18 19 9 229 211 466 448 l433
432 437 -437 c241 -240 453 -444 472 -453 114 -57 258 23 269 149 8 103 22 87
-537 648 -539 541 -558 558 -641 558 -19 0 -53 -9 -75 -19z"
      />
    </g>
  </Icon>
);

export default ArrowCircleUp;
